import { render, staticRenderFns } from "./zxFooter.vue?vue&type=template&id=0377742e&scoped=true"
import script from "./zxFooter.vue?vue&type=script&lang=js"
export * from "./zxFooter.vue?vue&type=script&lang=js"
import style0 from "./zxFooter.vue?vue&type=style&index=0&id=0377742e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0377742e",
  null
  
)

export default component.exports